import { render } from "./CovidPolicy.vue?vue&type=template&id=3654cd9a"
import script from "./CovidPolicy.vue?vue&type=script&lang=js"
export * from "./CovidPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__